import React, { useState, useCallback } from 'react';
import FeatureSelect from './FeatureSelect';
import { provideMapState, ensureMap, WmsLayer, MapEvent } from '@avinet/react-openlayers';
import config from '../../config/kystverket';
import useSearch from '../../hooks/useSearch';

const Layers = props => {
  const [showPopup, setShowPopup] = useState(false);
  const [coordinates, setCoordinates] = useState();
  const [searchRadius, setSearchRadius] = useState();

  const onMapSingleClick = useCallback(
    e => {
      const { mapZoom, getResolution } = props;
      const resolution = getResolution(mapZoom);
      props.setCenter(e.coordinate, props.mapZoom);

      let searchRadius = 6 * resolution;
      if (searchRadius < 12) searchRadius = 12;
      if (searchRadius > 10000) searchRadius = 10000;

      setCoordinates(e.coordinate);
      setSearchRadius(searchRadius);
      setShowPopup(true);
    },
    [props]
  );

  const { items, loading } = useSearch({ coordinates: coordinates, searchRadius: searchRadius });

  const onPopupClose = useCallback(() => {
    setShowPopup(false);
  }, []);

  return (
    <>
      <MapEvent onMapSingleClick={e => onMapSingleClick(e)} />

      {showPopup && <FeatureSelect items={items} onPopupClose={onPopupClose} loading={loading} />}

      <WmsLayer
        id="Port without Svalbard"
        name="Port without Svalbard"
        uri={config.a4WmsUrl}
        layerName={config.layerIds.port_without_svalbard}
        version="1.1.1"
        singleTile
        key="port_without_svalbard"
        minZoom={9}
      />
      <WmsLayer
        id="Port Svalbard"
        name="Port Svalbard"
        uri={config.a4WmsUrl}
        layerName={config.layerIds.port_svalbard}
        version="1.1.1"
        singleTile
        key="port_svalbard"
      />
      <WmsLayer
        id="Port facilities without Svalbard"
        name="Port facilities without Svalbard"
        uri={config.a4WmsUrl}
        layerName={config.layerIds.port_facilities_without_svalbard}
        version="1.1.1"
        singleTile
        key="port_facilities_without_svalbard"
        minZoom={9}
      />
      <WmsLayer
        id="Port facilities Svalbard"
        name="Port facilities Svalbard"
        uri={config.a4WmsUrl}
        layerName={config.layerIds.port_facilities_svalbard}
        version="1.1.1"
        singleTile
        key="port_facilities_svalbard"
      />
      <WmsLayer
        id="Quay without Svalbard"
        name="Quay without Svalbard"
        uri={config.a4WmsUrl}
        layerName={config.layerIds.quay_without_svalbard}
        version="1.1.1"
        singleTile
        key="quay_without_svalbard"
        minZoom={9}
      />
      <WmsLayer
        id="Quay Svalbard"
        name="Quay Svalbard"
        uri={config.a4WmsUrl}
        layerName={config.layerIds.quay_svalbard}
        version="1.1.1"
        singleTile
        key="quay_svalbard"
      />
      <WmsLayer
        id="Routes"
        name="Routes"
        uri={config.a4WmsUrl}
        layerName={config.layerIds.routes}
        version="1.1.1"
        singleTile
        key="routes"
      />
      {/* <WmsLayer
        id="Anchorage for sea transport"
        name="Anchorage for sea transport"
        uri={config.a4WmsUrl}
        layerName="dok-anchoragearea"
        version="1.1.1"
        singleTile
        key="anchorage"
      /> */}
    </>
  );
};

export default ensureMap(provideMapState(Layers));
